<template>
  <div class="activation-success page">
    <header-main>{{ $t("page.activation_success.mainheader") }}</header-main>

    <div class="activation-success__content">
      <p class="activation-success__text">
        {{ $t("page.activation_success.text1") }}
      </p>

      <integration-select
        :options="{ title: false }"
        :isOpening="true"
        :filter="messenger"
        @selectIntegration="openInstruction"
      />

      <div class="activation-success__notes">
        <p class="activation-success__note">
          <b>{{ $t("page.activation_success.important") }}</b>
          {{ $t("page.activation_success.warning", { msgr: messengerName }) }}
        </p>
        <p class="activation-success__note">
          {{ $t("page.activation_success.phone_offline") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import IntegrationSelect from "@/components/Recurring/IntegrationSelect";

const KNOWLEDGE_BASE_URL = "https://help.e-chat.tech/";

const MESSENGER_NAMES = {
  viber: "Viber",
  telegram: "Telegram",
  whatsapp: "WhatsApp",
};

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const messenger = computed(() => route.query.messenger || "");

const messengerName = computed(
  () =>
    MESSENGER_NAMES[messenger.value] ||
    t("page.activation_success.messenger_fallback")
);

const openInstruction = (crmName) => {
  if (crmName === "API") {
    router.push({ name: "API" });
  } else {
    window.open(KNOWLEDGE_BASE_URL, "_blank", "noopener");
  }
};
</script>

<style lang="scss">
.activation-success.page {
  margin: 20px;

  .integration-select > .integration-select-content {
    justify-content: flex-start;
  }
}

.activation-success {
  &__content {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  &__text {
    margin: 0;
    color: var(--text-third-color);
    font-family: "Gilroy", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 170%;
  }

  &__notes {
    padding-top: 20px;
    border-top: 1px solid #cdcaf3;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__note {
    margin: 0;
    color: var(--text-third-color);
    font-family: "Gilroy", sans-serif;
    font-size: 15px;
    font-weight: 500;
    line-height: 170%;

    b {
      font-weight: 700;
      color: var(--text-color);
    }
  }

  @media screen and (max-width: 680px) {
    &__text,
    &__note {
      font-size: 14px;
      line-height: 150%;
    }
  }
}
</style>
